module.exports = __webpack_public_path__ + "static/media/product-reviews-shopify.0b71b3a7.png";